import React from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { Message } from 'semantic-ui-react'
import styled from 'styled-components'
import { formatNumber } from '~/utils/helpers'

const StyledMessage = styled(Message)`
background-color: #fcfff5 !important;
color: #2c662d !important;
width: fit-content !important;
`

const Total:React.FC = () => {
  const { control } = useFormContext()
  const watchField = useWatch({ control, name: 'grassSilage.organicFertilizers' }) || []

  const sum = watchField.reduce((total, item) => {
    const numericValue = parseFloat(item?.value?.replace(',', '.'));
    const nitroValue = parseFloat(item?.n?.replace(',', '.'));
    const nitroTransformed = isNaN(nitroValue) ? 0 : nitroValue
    return total + (isNaN(numericValue) ? 0 : numericValue * nitroTransformed);
  }, 0)

  return <StyledMessage>
    <Message.Header>{'Ihr Stickstoffgehalt des aufgebrachten Wirtschaftsdüngers beträgt:'}</Message.Header>
    <Message.Content>{`${formatNumber(sum, 2)} kg N/ha`}</Message.Content>
  </StyledMessage>
}
export default Total